<h2 class="dialog-header">{{consts.TITLE_MAIN}}
    <mat-icon
        class="dialog-close-button"
        mat-dialog-close
        svgIcon="hub_close"
    >
    </mat-icon>
</h2>
<div class="dialog-body">
    <form [formGroup]="editForm" #localForm="ngForm" class="edit-form">
        <div class="fav-dialog-content">
            <p class="desc-text">
                {{consts.LABEL_MAIN}}
                <span class="required text-center">
                    {{consts.LABEL_REQUIRED}}
                </span>
            </p>
            <mat-dialog-content>
                <div class="row">
                    <div class="col-12">
                        <label class="form-label">
                            {{consts.LABEL_EDIT_TITLE}}
                        </label>
                        <span
                            *ngIf="editForm.get('name')?.invalid && localForm.submitted"
                            class="required"
                        >
                            {{consts.LABEL_EDIT_TITLE_REQUIRED}}
                        </span>
                        <input
                            matInput
                            class="form-element"
                            formControlName="name"
                            id="customTitle"
                            placeholder="{{consts.PLACEHOLDER_TITLE}}"
                            type="text"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label class="form-label">
                            {{consts.LABEL_EDIT_URL}}
                        </label>
                        <span
                            *ngIf="editForm.get('link')?.invalid && localForm.submitted"
                            class="required"
                        >
                            <ng-container *ngIf="editForm.get('link')?.errors?.required">
                                {{consts.LABEL_EDIT_URL_TITLE_REQUIRED}},
                            </ng-container>
                            <ng-container *ngIf="editForm.get('link')?.errors?.invalidUrl">
                                {{consts.LABEL_EDIT_URL_INVALID}}
                            </ng-container>
                        </span>
                        <input
                            matInput
                            class="form-element"
                            formControlName="link"
                            id="customUrl"
                            placeholder="{{consts.PLACEHOLDER_URL}}"
                            type="text"
                        >
                    </div>
                </div>
            </mat-dialog-content>
        </div>
        <mat-dialog-actions class="fav-mat-actions">
            <button
                mat-button
                mat-dialog-close
                class="cancel-btn"
            >
                {{consts.BUTTON_CANCEL}}
            </button>
            <button
                mat-raised-button
                class="save-btn"
                (click)="onSave()"
            >
                {{consts.BUTTON_SAVE}}
            </button>
        </mat-dialog-actions>
    </form>
</div>
